<template>
  <div>
    <div class="user-menu pb-3" @select="onMenuSelect">
      <div v-loading="$store.state.app.loadingList.includes('orgView-userMenu')" class="my-loading">
        <div v-if="orgInfo" class="py-4 px-4 row-start cursor-hand align-start" @click="onOrgSetting">
          <div class="mr-3 border-a border-radius-m">
            <el-image
              style="width: 45px; height: 45px"
              :src="orgLogo"
              fit="contain"
            /></div>
          <div>
            <div class="is-fs-l">{{ orgInfo.name }}</div>
            <div class="mt-2_5">
              <el-tag size="mini" type="success" class="mr-1">{{ orgInfo.sub.sku_name }}</el-tag>
              <el-tag v-if="orgInfo.sub.is_expired" size="mini" type="danger">已过期</el-tag>
            </div>
          </div>
          <!-- <div>{{ ai }}</div> -->
        </div>
      </div>
      <div class="py-4 border-t px-4">
        <el-button type="primary" style="width: 100%;" @click="onCreateForm"><span class="iconfont icon-plus" /> 新建表单</el-button>
      </div>

      <div
        class="px-4 py-4 cursor-hand"
        :class="{'has-text-primary': $route.path == `/form/org/${orgId}/me`}"
        @click="onMenuSelect(`/form/org/${orgId}/me`)"
      >
        <span class="iconfont icon-file-text mr-1" />
        <span>我的表单</span>
      </div>
      <div
        class="px-4 py-4 cursor-hand"
        :class="{'has-text-primary': $route.path == `/form/org/${orgId}/co`}"
        @click="onMenuSelect(`/form/org/${orgId}/co`)"
      >
        <span class="iconfont icon-file-text mr-1" />
        <span>协管表单</span>
      </div>
      <div
        class="px-4 py-4 cursor-hand"
        :class="{'has-text-primary': $route.path == `/user/org/${orgId}`}"
        @click="onMenuSelect(`/user/org/${orgId}`)"
      >
        <span class="iconfont icon-team mr-1" />
        <span>成员</span>
      </div>
      <div
        class="px-4 py-4 cursor-hand"
        :class="{'has-text-primary': $route.path == `/file/org/${orgId}/me`}"
        @click="onMenuSelect(`/file/org/${orgId}/me`)"
      >
        <span class="iconfont icon-file-image mr-1" />
        <span>我的素材</span>
      </div>
      <div
        v-show="orgRole === config.ORG_ROLE_ADMIN"
        class="px-4 py-4 cursor-hand"
        :class="{'has-text-primary': $route.path == `/form/org/${orgId}/admin`}"
        @click="onMenuSelect(`/form/org/${orgId}/admin`)"
      >
        <span class="iconfont icon-file-text-fill mr-1" />
        <span>全部表单</span>
      </div>
      <div
        v-show="orgRole === config.ORG_ROLE_ADMIN"
        class="px-4 py-4 cursor-hand"
        :class="{'has-text-primary':
          $route.path == `/file/org/${orgId}/admin`}"
        @click="onMenuSelect(`/file/org/${orgId}/admin`)"
      >
        <span class="iconfont icon-file-image-fill mr-1" />
        <span>全部素材</span>
      </div>
      <div
        class="px-4 py-4 cursor-hand"
        :class="{'has-text-primary': $route.path == `/org/${orgId}/setting`}"
        @click="onMenuSelect(`/org/${orgId}/setting`)"
      >
        <span class="iconfont icon-setting mr-1" />
        <span>关于工作区</span>
      </div>
      <div
        v-show="orgRole === config.ORG_ROLE_ADMIN"
        class="px-4 py-4 cursor-hand"
        :class="{'has-text-primary':
          $route.path == `/order/create?org_id=${orgId}`}"
        @click="onMenuSelect(`/order/create?org_id=${orgId}`)"
      >
        <span class="iconfont icon-crown mr-1" />
        <span>套餐充值</span>
      </div>
      <div
        v-show="orgRole === config.ORG_ROLE_ADMIN"
        class="px-4 py-4 cursor-hand"
        :class="{'has-text-primary':
          $route.path == `/order/org/${orgId}`}"
        @click="onMenuSelect(`/order/org/${orgId}`)"
      >
        <span class="iconfont icon-shopping mr-1" />
        <span>订单</span>
      </div>
      <!-- <div index="page-list">
        <span class="iconfont icon-Field-time mr-1" />
        <span>最近查看表单</span>
      </div> -->

      <!-- <div index="page-list">
        <span class="iconfont icon-edit mr-1" />
        <span>我的答复</span>
      </div>
      <div index="page-list" >
        <span class="iconfont icon-qrcode mr-1" />
        <span>我的企业</span>
      </div> -->
      <!-- <div index="page-list">
        <span class="iconfont icon-delete mr-1" />
        <span>回收站</span>
      </div> -->

    </div>
    <DlgCreateForm v-model="dlgCreateForm.val" />

  </div>
</template>

<script>
// import { view as orgView } from '@/api/org'
import config from '@/config/index'
import { mapGetters } from 'vuex'
import DlgCreateForm from '@/components/DlgCreateForm.vue'
import { openPage } from '@/utils/index'
export default {
  name: 'UserMenu',
  components: {
    DlgCreateForm
  },
  props: {},
  data() {
    return {
      config,
      orgId: 0,
      ai: 'ai3',
      orgRole: config.ORG_ROLE_MEMBER, // 3: 普通用户 2: 管理员
      dlgCreateForm: {
        val: {
          visible: false
        },
        params: {
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'orgInfo'
    ]),
    orgLogo() {
      return this.orgInfo.logo ? this.orgInfo.logo : `${process.env.VUE_APP_WEBAPP_BASE_URL}/assets/default-avatar.jpg`
    }
  },
  async created() {
    const workspaceId = localStorage.getItem('bd_webapp_orgId')
    this.orgId = workspaceId // this.$route.params.id
    this.orgRole = localStorage.getItem('bd_webapp_orgRole')
    // await this.fetchOrg(workspaceId)
  },
  mounted() {
    console.log(this.$route.path)
    this.ai = 'ai1'
    console.log(this.ai)
  },
  activated() {
    console.log(this.$route.path)
    this.ai = 'ai2'
    console.log(this.ai)
  },
  methods: {

    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    onMenuSelect(index) {
      // 手机端，点了菜单，关闭左侧菜单
      this.$store.dispatch('app/setShowLeftbarDrawer', false)
      console.log('菜单select事件：', index)
      if (index.startsWith('/order/create')) {
        openPage({
          path: index
        }, this)
      } else {
        this.$router.push({
          path: index
        })
      }
    },
    onCreateForm() {
      const that = this
      that.$store.dispatch('app/setShowLeftbarDrawer', false)

      // that.dlgCreateForm.val.visible = true
      openPage({
        name: 'TplList'
      }, that)
    },
    onOrgSetting() {
      // 手机端，点了菜单，关闭左侧菜单
      this.$store.dispatch('app/setShowLeftbarDrawer', false)
      this.$router.push({
        name: 'OrgSetting',
        params: { orgId: this.orgId }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu {
  // background: transparent;
  border: 0px;
}
</style>
